module.exports = __webpack_public_path__ + "img/star7-10.48fb47b6.svg";